import script from "./InstallPWAModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InstallPWAModal.vue?vue&type=script&lang=ts&setup=true"

import "./InstallPWAModal.vue?vue&type=style&index=0&id=4ea59575&lang=scss"

const __exports__ = script;

export default __exports__